import { ShieldCheck } from "@phosphor-icons/react";
import { PolicyPage } from "@/components/PolicyPage";
import { PRIVACY_POLICY } from "@/data/business";

export default function PrivacyPolicy() {
  return (
    <PolicyPage
      testId="privacy-policy-page"
      icon={ShieldCheck}
      title="Privacy Policy"
      intro="Your memories are yours. Here is exactly what we collect, why, and how you stay in control."
      sections={PRIVACY_POLICY}
    />
  );
}
